import { carouselData } from '@/mocks/chiguaHomeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            编辑精选的深度吃瓜专题，一次看个够
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="relative rounded-2xl overflow-hidden group cursor-pointer block aspect-[16/9]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-[11px] font-medium rounded-md mb-3 whitespace-nowrap">
                  {item.label}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-background-50 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-background-50/80">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}